/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const coolingHVACEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type CoolingHVACEnumsPotentialConsequenceOptionEnumKey =
    (typeof coolingHVACEnumsPotentialConsequenceOptionEnum)[keyof typeof coolingHVACEnumsPotentialConsequenceOptionEnum];

export type CoolingHVACEnumsPotentialConsequenceOption = CoolingHVACEnumsPotentialConsequenceOptionEnumKey;
